

import Vue from 'vue'
import FastClick from 'fastclick'

import router from './router'
import axios from 'axios'
import qs from 'qs'
import App from './App'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'



const vuxComponents = {
Group,
Cell,
Selector,
XInput,
PopupRadio,
XButton,
Checker,
CheckerItem,
Datetime,
XTextarea,
XNumber,
Flexbox,
FlexboxItem,
Scroller,
LoadMore,
Toast,
Confirm,
Divider,
CheckIcon,
Checklist,
PopupPicker,
Popup
};

const vuxPlugins = [AlertPlugin, LoadingPlugin, ToastPlugin, ConfirmPlugin];

Object.keys(vuxComponents).forEach((k) => {
Vue.component(k, vuxComponents[k])
});

vuxPlugins.forEach((plugin) => {
Vue.use(plugin)
});

let options = {
fullscreenEl: false, //控制是否显示右上角全屏按钮
closeEl: false, //控制是否显示右上角关闭按钮
tapToClose: true, //点击滑动区域应关闭图库
shareEl: false, //控制是否显示分享按钮
zoomEl: false, //控制是否显示放大缩小按钮
counterEl: false, //控制是否显示左上角图片数量按钮
arrowEl: false,  //控制如图的左右箭头（pc浏览器模拟手机时）
tapToToggleControls: true, //点击应切换控件的可见性
clickToCloseNonZoomable: true 
};
Vue.use(preview, options)

FastClick.attach(document.body);



/**
* showToast对vux的toast插件进行封装
* @param text [内容]
* @param time [持续显示时间]
* @param type [类型，可选值 success, warn, cancel, text]
* @param options [type: object] [可传入toast插件支持的其他属性]
*/
Vue.prototype.showToast = function (text, time = 1500, type = 'text', options = {}) {
this.$vux.toast.show({
text: text,
type: type,
time: time,
position: options.position || 'default',
width: options.width || '7.6em',
isShowMask: options.isShowMask || false,
onHide: options.onHide
})
};

/**
* $http是配置axios，只要调用$http，那请求的参数都会被序列化为Form data
* @type {AxiosInstance}
* 使用到qs插件来序列化；
* 写入Vue.prototype，可全局使用该函数；
* 注：如果请求参数不需要序列化，可直接在组件内引入axios
*/
Vue.prototype.$http = axios.create({
transformRequest: [function (data) {

data = qs.stringify(data); 
return data;
}]
}); // 将axios添加到Vue原型中


/**
* requestApi是对$http进行多一层封装，处理下后台返回code为412或500的情况
* option [type:object] [传递请求需要的类型、url、参数等] [url必须传！];
* okCallback [type:fn] [后台返回的code为不为412或500时，运行该函数，对数据进行处理];
* statusCallback [type:fn] [在该函数中可控制各种状态，比如是否显示、可继续请求等状态];
* 注：statusCallback是请求成功或失败都可以执行的，如果需要只有在请求失败时才执行，可在该函数中用if(error){ 只有请求失败才执行 }；
*/
Vue.prototype.requestApi = function (option, okCallback, statusCallback) {
if (!option.url) {
console.error("没传url啊");
}
this.$http({
method: option.method || 'post',
url: option.url, // url必须有
data: option.data || {}
})
.then((res) => {
let resultData = res.data; 
let code = resultData.code;
let info = resultData.info; 
if (code === 412) {
this.$vux.toast.show({

text: info,
time: 1500,
type: 'warn'
})
} else if (code === 500) {
this.$vux.toast.show({

text: info,
time: 1500,
type: 'warn'
})
} else {
okCallback && okCallback(resultData)
}

statusCallback && statusCallback()
})
.catch((error) => {
statusCallback && statusCallback(error);
console.error(error); 

this.$vux.toast.show({
text: '网络超时！',
time: 1500,
type: 'warn'
})
});
};


Vue.config.productionTip = false;


/**
* getUrlParams获取url里拼接的参数
* USAGE:
* let paramName = getUrlParams('paramName');
* let { param1, param2 } = getUrlParams('param1', 'params2');
* @returns {Object, Array}
*/
Vue.prototype.getUrlParams = function () {
function getByName(name) {
const reg = new RegExp(`(^|&|\\?)${name}=([^&]*)(&|$)`, 'i');
const param = window.location.href.substring(1).match(reg);
if (param !== null) {
if (param[2].indexOf('#') !== -1) {

const reg2 = /([^&]*)#/;
const param2 = param[2].match(reg2);
return param2[1]
}
return param[2];
}
return undefined;
}

if (arguments.length === 1) {
return getByName(arguments[0]) || {};
}
let result = {};
[...arguments].forEach((name) => {
result[name] = getByName(name);
});
return result;
};

Date.prototype.Format = function (fmt) { //
if (!this.getDate()) return;

let o = {
'M+': this.getMonth() + 1, // 月份
'd+': this.getDate(), // 日
'H+': this.getHours(), // 小时
'm+': this.getMinutes(), // 分
's+': this.getSeconds(), // 秒
'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
'S': this.getMilliseconds() // 毫秒
};
if (/(y+)/.test(fmt)) {
fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
}
for (var k in o) {
if (new RegExp('(' + k + ')').test(fmt)) {
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
}
}
return fmt;
};

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box');



// WEBPACK FOOTER //
// ./src/main.js